export default function toSalusionMarketing(event, path = "", newWindow = true) {
	if (event) event.preventDefault()

	let hostname = window.location.hostname
	hostname = hostname.replace(/^www\./, "")
	hostname = hostname.replace(/^my\./, "")

	path = path.replace(/^\/+/, "")

	let target = "_self"
	if (newWindow) target = "_blank"

	if (hostname === "localhost") {
		window.open(`http://localhost:3000/${path}`, target)
	} else {
		window.open(`https://${hostname}/${path}`, target)
	}
}
